import React from "react";
import style from "./Fields.module.scss";
import { Field } from "../../Order/Field/Field";
import Autosuggest from "../../../Autosuggest/Autosuggest";

const SimpleSuggest = ({ value, error, disabled, onChange, label, noLabel, service }) => {
  const fetchSearch = ({ value }) => {
    return service({
      text: value,
      length: 10,
    })
      .then((r) => (r.response ? r.response : r))
      .then((r) => r[Object.keys(r)[0]])
      .then((values) =>
        values.slice(0, 9).map((s) => ({
          id: s.Id,
          name: `${s.Name || s.Value}`,
        }))
      );
  };

  const internalOnChange = (method, value) => {
    const _value = {
      id: null,
      name: "",
    };

    if (method != "type" && value.id) {
      _value.id = value.id;
      _value.name = value.name;
    }
    onChange(_value);
  };

  return (
    <Field label={label} noLabel={noLabel} error={error}>
      <Autosuggest
        renderSuggestion={(suggestion) => (
          <div className={style.suggestionItem}>
            <span>{suggestion.name}</span>
          </div>
        )}
        getSuggestionValue={(s) => `${s.name}`}
        onSuggestionsFetchRequested={fetchSearch}
        value={value || ""}
        inputProps={{
          placeholder: label,
          invalid: !!error,
          disabled,
        }}
        onChange={(m, v) => internalOnChange(m, v)}
      />
    </Field>
  );
};

export default SimpleSuggest;
